import React from 'react';
import './BigButton.css';

const BigButton = ({ onClick, color, icon, label, className = '' }) => {
    return (
        <button
            className={`big-button ${className}`}
            onClick={onClick}
            style={{ backgroundColor: color }}
        >
            <div className="big-button-content">
                {icon && <div className="big-button-icon">{icon}</div>}
                {label && <span className="big-button-label">{label}</span>}
            </div>
        </button>
    );
};

export default BigButton;
